import styled from "@emotion/styled";

export const Styled = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.gray[2]};
  width: fit-content;
  padding: 0.1em 0.5em;
  border-radius: 0.25em;
`;
